import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';

import { onDoLogout } from '@/redux/auth';
import { encrypt, authStorage } from '@ajaibid/utils';
import { usePinData } from '@services/users/pin/index';
import useAjaibConfig from '@/hooks/useAjaibConfig';

import { AES_ENCRYPTION_SECRET_KEY, COOKIE_KEY } from '@config/constanta';
import { PopUpDialog } from 'Component/PopUp';
import { InputPinBox } from 'Component/PinBox';
import PinProvider from 'Component/PinBox/context';

import { styContainer } from './style';
import useEventTracker from './tracker';

const LoginPin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showPopupLogout, setShowPopupLogout] = useState(false);

  const { pinData } = usePinData();

  const { config } = useAjaibConfig();
  const isLoginOtp = config?.is_login_using_otp === '1';
  const getOtpSource = Cookies.get(COOKIE_KEY.is_from_otp);
  const { eventClickLogout } = useEventTracker();

  useEffect(() => {
    if (isLoginOtp && !getOtpSource) {
      navigate('/otp');
    }
  }, [isLoginOtp, getOtpSource]);

  const handleValidatePinSuccess = () => {
    const pinToken = Cookies.get(COOKIE_KEY.pin_token);
    if (pinToken) {
      const ciphertext = encrypt(pinToken, AES_ENCRYPTION_SECRET_KEY);
      authStorage.set('xyz', ciphertext);
    }

    navigate('/home');
  };

  return (
    <>
      <div className={styContainer}>
        <PinProvider>
          <InputPinBox
            isShowLogout
            onSuccess={handleValidatePinSuccess}
            onBeforeLogout={() => setShowPopupLogout(true)}
          />
        </PinProvider>
      </div>

      <PopUpDialog
        display={showPopupLogout}
        title="Ubah Akun?"
        subtitle={`Mengubah akun akan membuat kamu keluar dari akun ${pinData?.email} saat ini. Apakah kamu yakin?`}
        actionPrimaryText="Batal"
        actionSecondaryText="Ya, Ubah"
        onActionPrimaryClick={() => setShowPopupLogout(false)}
        onActionSecondaryClick={() => {
          const payload = {
            fcm_token: Cookies.get('notification_token'),
          };
          eventClickLogout();
          dispatch(onDoLogout(payload));
        }}
      />
    </>
  );
};

export default LoginPin;
